module.exports = __webpack_public_path__ + "img/按钮2.c74264da.png";